import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faAlignJustify,
    faBook,
    faCloudDownloadAlt,
    faFile,
    faIndustry,
    faPlusSquare,
    faSpinner,
    faSync,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(faAlignJustify, faBook, faSync, faFile, faPlusSquare, faCloudDownloadAlt, faSpinner, faIndustry);

import * as React from 'react';
import Composer from '../Composer';
import Logo from '../images/logo-aop.png';
import Logging from '../Logging';
import { MainComposer } from '../logic/composer';
import { MainFileEditorController } from '../logic/fileeditor';
import { handleInvalidJson, IResponseResult, onResult, sendRequest } from '../logic/requester';
import { bufferToString } from '../logic/util';
import Popup from '../Popup';
import Result from '../Result';
import { getSamples } from '../samples';
import Templates from '../Templates';
import './style.css';
import Title from './Title'


interface IAppState {
    result?: IResponseResult | null;
    samples: boolean;
    view: 'editor' | 'logging';
    serverUrl: string;
    editMode: boolean;
    invalid: boolean;
    errorMessage: string;
}

class App extends React.Component<any, IAppState> {
    protected cache: Templates;
    protected json: Templates;
    protected composer: Composer;
    protected logging: Logging;

    constructor(props: any, context: any) {
        super(props, context);
        this.state = { samples: false, view: 'editor', serverUrl: '', editMode: false, invalid: false, errorMessage: '' };
        onResult(result => this.setState({ result: result || null }));
        MainFileEditorController.onChange((mfec) => {
            if (mfec.getTemplate() === undefined) {
                this.setState({ editMode: false });
            } else {
                this.setState({ editMode: true });
                this.composer.injectFilesData();
            }
        });
    }

    public onClickLoadSample = (json: any) => () => {
        this.closeSample();
        MainComposer.set(json);
        this.composer.extractFilesData();
        return false
    };

    public componentDidMount() {
        MainComposer.onChange(() => this.forceUpdate());
        this.json.onChange(() => {
            const json = this.json.getTemplates()[0];
            if (!json) return;
            this.json.clear();
            if (!('buffer' in json)) {
                console.error('No buffer in data'); // TO DO
                return;
            }
            try {
                let parsedJson;
                try {
                    parsedJson = JSON.parse(bufferToString(json.buffer));
                }
                catch (e) {
                    // alert(e.name + " : " + e.message);
                    // this.setState({ result: e });
                    this.setState({ invalid: true, errorMessage: e });
                    return;
                }
                MainComposer.set(parsedJson);
                this.composer.extractFilesData();
            } catch (e) {
                console.error(e); // TODO: Error handling
            }
        });
    }

    public render() {
        return (
            <div className="App">
                <header>
                    <ul className="menu">
                        <li><a href="https://www.apexofficeprint.com/docs/" target="_blank"><FontAwesomeIcon
                            icon="book" /> Documentation</a></li>
                        <li>
                            <button onClick={this.switchView}><FontAwesomeIcon
                                icon="align-justify" /> {this.state.view === 'editor' ? 'Logging' : 'Editor'}</button>
                        </li>
                    </ul>
                    <img src={Logo} alt="AOP logo" />
                    <div className="center">
                        <h1>APEX Office Print</h1>
                        <Title />
                    </div>
                </header>
                <div className={`content center ${this.state.view === 'editor' ? '' : 'hidden'}`}>
                    <h3>Drop exported JSON</h3>
                    <Templates name="JSON" ref={r => this.json = r!} single={true} noRender={true} />
                </div>
                <div className={`content editor ${this.state.view === 'editor' ? '' : 'hidden'}`}>
                    <Popup visible={this.state.result === null} close={this.hideEditor}>Loading <FontAwesomeIcon
                        icon="spinner" spin={true} /></Popup>
                    <Popup visible={this.state.invalid} close={this.closeInvalid}>
                        Invalid JSON File. Please check your file.
                    </Popup>
                    {/* RIGHT COLUMNS */}
                    <div className="box column right filecache">
                        <button className="app clear cache" onClick={this.clearCache}><FontAwesomeIcon icon="sync" /></button>
                        <h3>File cache</h3>
                        <p>Temporarily store files here to drag them to the left later</p>
                        <Templates name="templates or other files" ref={r => this.cache = r!} />
                    </div>
                    {/* LEFT COLUMNS */}
                    <div className="box column left">
                        {/*<button className="app send" onClick={this.sendJSON}>Send</button>*/}
                        <button className="app clear" onClick={this.clearComposer}><FontAwesomeIcon icon="sync" /> Clear
                        </button>
                        <button className="app samples info" onClick={this.showSample}><FontAwesomeIcon
                            icon="cloud-download-alt" /> Load sample
                        </button>
                        <div className="dropdown">
                            <div className={` ${this.state.samples ? 'dropdown-content' : 'hidden'}`}>
                                {getSamples().map(([name, json]) => <a className="load-sample" key={name}
                                    onClick={this.onClickLoadSample(json)}>{name}</a>)}
                            </div>
                        </div>
                        <h3>Composer</h3>
                        <Composer ref={(r: any) => this.composer = r!} getFilecache={this.getFileCache} />
                    </div>
                    <div className="box column left">
                        <h3>Output</h3>
                        <div className="output">
                            <select className="output-type" onChange={this.setOutputType} value={MainComposer.outputType}>
                                <option value="docx">Word (docx)</option>
                                <option value="docm">Word Macro Enabled (docm)</option>
                                <option value="rtf">Rich Text Format (rtf)</option>
                                <option value="xlsx">Excel (xlsx)</option>
                                <option value="xlsm">Excel Macro Enabled(xlsm)</option>
                                <option value="csv">Comma Separated Value (csv)</option>
                                <option value="pptx">PowerPoint (pptx)</option>
                                <option value="pptm">PowerPoint Macro Enabled (pptx)</option>
                                <option value="pdf">PDF (pdf)</option>
                                <option value="onepagepdf">One Page PDF (pdf)</option>
                                <option value="html">HTML (html)</option>
                                <option value="md">Markdown (md)</option>
                                <option value="txt">Text (txt)</option>
                                <option value="ics">Calendar (ics)</option>
                                <option value="odt">OpenDocument Text (odt)</option>
                                <option value="ods">OpenDocument Spreadsheet (ods)</option>
                                <option value="odp">OpenDocument Presentation (odp)</option>
                            </select>
                            <input
                                className="output-type server-url"
                                type="text"
                                value={this.state.serverUrl}
                                onChange={this.setServerUrl}
                                placeholder="Server URL (or empty for webeditor url)"
                            />
                            <button className="send process" onClick={this.sendJSON}><FontAwesomeIcon
                                icon="industry" /> Process
                                </button>
                        </div>
                    </div>
                </div>
                <div className={`content logging ${this.state.view === 'logging' ? '' : 'hidden'}`}>
                    <div className="box options">
                        <h3>Logging</h3>
                        <input
                            type="text"
                            value={this.state.serverUrl}
                            onChange={this.setServerUrl}
                            placeholder="Server URL (or empty for webeditor url)"
                        />
                        <button onClick={this.fetchLog}>Fetch log</button>
                        <button onClick={this.downloadLog}>Download (JSON)</button>
                        <button onClick={this.downloadCSV}>Download (CSV)</button>
                        <button onClick={this.showStatistics}>Show statistics</button>
                    </div>
                    <div className="box logging">
                        <Logging ref={r => this.logging = r!} />
                    </div>
                </div>
                <div className={`content center ${this.state.view === 'editor' ? '' : 'hidden'}`}>
                    {this.state.result && <Result result={this.state.result || undefined} hide={this.hideEditor} />}
                </div>
            </div>
        );
    }

    protected switchView = () => {
        if (this.state.view === 'editor') this.fetchLog();
        this.setState({ view: this.state.view === 'editor' ? 'logging' : 'editor' });
    };
    protected hideEditor = () => {
        this.setState({ result: undefined, editMode: false });
        MainFileEditorController.stopEditing()
    };
    protected closeInvalid = () => {
        this.setState({ invalid: false });
        handleInvalidJson(this.state.errorMessage);
    };
    protected clearCache = () => this.cache.clear();
    protected clearComposer = () => (this.composer.clear(), this.hideEditor());
    protected showSample = () => this.setState({ samples: true }, () => { document.addEventListener('click', this.closeSample); });
    protected closeSample = () => this.setState({ samples: false }, () => { document.removeEventListener('click', this.closeSample); });
    protected sendJSON = () => sendRequest(MainComposer.calculated, this.state.serverUrl);
    protected setOutputType = (event: React.ChangeEvent<HTMLSelectElement>) => MainComposer.outputType = event.target.value;
    protected getFileCache = () => this.cache;
    protected setServerUrl = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ serverUrl: event.target.value });
    protected fetchLog = () => this.logging.fetch(this.state.serverUrl);
    protected downloadLog = () => this.logging.downloadLog();
    protected downloadCSV = () => this.logging.downloadCSV();
    protected showStatistics = () => this.logging.showStatistics();
}

export default App;



// WEBPACK FOOTER //
// ./src/App/index.tsx